<div class="tree">
    <ng-content></ng-content>
</div>